import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCZ6Dm2tvzDSIyHbXm9ihhzlUySzbwsKQs",
  authDomain: "back-end-b3c23.firebaseapp.com",
  projectId: "back-end-b3c23",
  storageBucket: "back-end-b3c23.firebasestorage.app",
  messagingSenderId: "979862453571",
  appId: "1:979862453571:web:c5a97bb5709a28b9f943f6",
  measurementId: "G-15J5HSMXBK"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);

